import http from "../http-common";

class CustomerService {
  getAll() {
    return http.get("/customers");
  }
  
  getDealers() {
    return http.get("/customers/dealers");
  }
  
  getClients() {
    return http.get("/customers/clients");
  }

  getDealerClients(dealerID) {
    return http.get(`/customers/clients?dealerid=${dealerID}`);
  }

  get(customerID) {
    return http.get(`/customers/${customerID}`);
  }

  create(data) {
    return http.post("/customers", data);
  }

  update(customerID, data) {
    return http.put(`/customers/${customerID}`, data);
  }

  delete(customerID) {
    return http.delete(`/customers/${customerID}`);
  }

  deleteAll() {
    return http.delete(`/customers`);
  }

  findByName(customerName) {
    return http.get(`/customers?customername=${customerName}`);
  }
}

export default new CustomerService();